import React, { useCallback, useContext, useRef } from "react";
import PropTypes from "prop-types";
import ReCAPTCHA from "react-google-recaptcha";
import { FormikContext } from "formik";
import { envs } from "../../../../config";
import ReCaptchaControlContainer, { Recaptcha } from "./ReCaptchaControl.Style";
import { FormContext } from "../../../../contexts";

const ReCaptchaControl = ({ badge, sitekey, type, size, theme, hl }) => {
  const { setFieldValue } = useContext(FormikContext);

  const { recaptcha } = useContext(FormContext);
  const recaptchaRef = useRef(null);

  const refreshHandle = useCallback(() => {
    recaptchaRef.current.reset();
    setFieldValue("g-captcha-response", "");
  }, [setFieldValue]);

  const changeHandle = useCallback(() => {
    if (recaptcha) {
      const recaptchaKey = recaptchaRef.current.getValue();
      setFieldValue("g-captcha-response", recaptchaKey);
      setFieldValue("gRefresh", refreshHandle);
    }
  }, [recaptcha, refreshHandle, setFieldValue]);

  return recaptcha ? (
    <ReCaptchaControlContainer>
      <Recaptcha
        as={ReCAPTCHA}
        ref={recaptchaRef}
        onChange={changeHandle}
        onExpired={refreshHandle}
        onErrored={refreshHandle}
        badge={badge}
        sitekey={sitekey}
        size={size}
        type={type}
        theme={theme}
        hl={hl}
      />
    </ReCaptchaControlContainer>
  ) : null;
};

ReCaptchaControl.defaultProps = {
  badge: "bottomright",
  type: "image",
  size: "normal",
  theme: "light",
  sitekey: envs.recaptchaKey,
  hl: "pt-BR",
};

ReCaptchaControl.propTypes = {
  badge: PropTypes.oneOf(["bottomright", "bottomleft", "inline"]),
  sitekey: PropTypes.string,
  type: PropTypes.oneOf(["image", "audio"]),
  size: PropTypes.oneOf(["compact", "normal", "invisible"]),
  theme: PropTypes.oneOf(["light", "dark"]),
  hl: PropTypes.string,
};

export default ReCaptchaControl;
